import { FC } from 'react'

import { Grid, Input, SimpleCollapse } from 'components'
import { Control } from 'react-hook-form'
import { SPACING } from 'utils'

import { IAddAnalysisCreForm } from '../AddAnalysisCre'

interface IDemaisInformacoesProps {
  control: Control<IAddAnalysisCreForm, any>
  errors: any
  novaAnalise?: boolean
  disabledFunctions?: boolean
}

const DemaisInformacoesCollapse: FC<IDemaisInformacoesProps> = ({
  control,
  novaAnalise,
  disabledFunctions,
  errors
}) => {
  return (
    <>
      <SimpleCollapse title="DEMAIS INFORMAÇÕES">
        <Grid
          gridCols="1fr 4fr 3fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing30} 0`}
        >
          <Input
            control={control}
            errors={errors}
            label="Nº Matricula"
            placeholder="Numero Matricula"
            formValue="cdMatricula"
            disabled
          />
          <Input
            control={control}
            errors={errors}
            label="Analista Responsável"
            placeholder="Nome do Analista Responsável"
            formValue="nmAnalista"
            disabled
          />
        </Grid>
        <Grid
          gridCols="7fr 1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing30} 0`}
        >
          <Input
            control={control}
            errors={errors}
            label="Observações"
            placeholder="Observações"
            formValue="txObservacao"
            disabled={disabledFunctions ? disabledFunctions : !novaAnalise}
          />
        </Grid>
      </SimpleCollapse>
    </>
  )
}

export default DemaisInformacoesCollapse
